import { ErrorMessage as RHFErrorMessage } from '@hookform/error-message';
import type { ReactNode } from 'react';
import type { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { type Dictionary, DictionaryService } from 'service/dictionary/dictionaryService';
import { getLabel } from '../../../DynamicForm/components/Inputs/helper';
import { ErrorMessage, FieldContainer, FormLabel, Input, MainLabel } from '../../../styles';

export type TextInputProps = {
  fieldName: string;
  required?: boolean;
  translations: Dictionary;
} & {
  register: UseFormRegister<FieldValues>;
  errors: FieldErrors<FieldValues>;
};

export const EmailInput = ({
  fieldName,
  required,
  register,
  errors,
  translations,
}: TextInputProps): ReactNode => {
  const requiredErrorMessage = DictionaryService.getCopy(
    'requiredMessage',
    translations.dictionaryItems,
  );
  const emailValidationErrorMessage = DictionaryService.getCopy(
    'emailValidationMessage',
    translations.dictionaryItems,
  );
  const label = DictionaryService.getCopy('emailLabel', translations.dictionaryItems);

  return (
    <FieldContainer>
      <MainLabel>
        <FormLabel tag="span" type="lead">
          {getLabel({ label, required })}
        </FormLabel>
        <Input
          {...register(fieldName, {
            required: { value: Boolean(required), message: requiredErrorMessage },
            pattern: { value: /^\S+@\S+\.\S+$/, message: emailValidationErrorMessage },
          })}
          type="text"
          placeholder={label}
        />
      </MainLabel>
      <RHFErrorMessage
        errors={errors}
        name={fieldName}
        render={({ message }: { message: string }) => <ErrorMessage>{message}</ErrorMessage>}
      />
    </FieldContainer>
  );
};
